import React, { useState } from 'react';
import './VideoShowCase.css';

const VideoShowcase = () => {
    const [isPlaying, setIsPlaying] = useState(false);

    // Wstaw tutaj URL swojego wideo (może być YouTube, Vimeo lub lokalny plik)
    // Przykładowe wideo z YouTube o mechanice samochodowej (możesz zmienić na swój link)
    const videoUrl = "https://res.cloudinary.com/dpe27l99d/video/upload/v1778433876/IMG_2350_fvmta3.mp4";

    return (
        <section id="video" className="video-section">
            <div className="container">
                <div className="section-title" data-aos="fade-up">Nasze realizacje</div>
                <div className="section-subtitle" data-aos="fade-up" data-aos-delay="100">
                    Zobacz jak pracujemy – profesjonalizm w każdym detalu
                </div>

                <div className="video-wrapper" data-aos="fade-up" data-aos-delay="200">
                    <div className="video-container aspect-ratio-1-1">
                        {!isPlaying ? (
                            <div className="video-placeholder" onClick={() => setIsPlaying(true)}>
                                <div className="placeholder-overlay"></div>
                                <div className="play-button">
                                    <i className="fas fa-play"></i>
                                </div>
                                <div className="placeholder-text">
                                    <i className="fas fa-wrench"></i>
                                    <p>Kliknij aby obejrzeć wideo</p>
                                </div>
                            </div>
                        ) : (
                            <iframe
                                src={videoUrl}
                                title="Strefa Napędu - nasze realizacje"
                                frameBorder="0"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                allowFullScreen
                                className="video-iframe"
                            ></iframe>
                        )}
                    </div>
                </div>

                <div className="video-features" data-aos="fade-up" data-aos-delay="300">
                    <div className="video-feature">
                        <i className="fas fa-microchip"></i>
                        <span>Naprawy hybryd i EV</span>
                    </div>
                    <div className="video-feature">
                        <i className="fas fa-oil-can"></i>
                        <span>Silniki i skrzynie biegów</span>
                    </div>
                    <div className="video-feature">
                        <i className="fas fa-tachometer-alt"></i>
                        <span>Nowoczesna diagnostyka</span>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default VideoShowcase;